import { makeStyles } from '@material-ui/core';
import { vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../mui-theme';

export const styles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: 'unset',
    minHeight: '95.96vh',
    background: themeColor.modalBackground,
  },
  dialogPaperFullWidth: {
    minWidth: '97.51vw',
  },
  mainContainer: {
    padding: '3.84vh 1.57vw 2vh 1.57vw',
  },
  flexGrowOne: {
    flexGrow: 1,
  },
  dialogDescriptionText: {
    marginTop: '1.30vh',
    marginBottom: '3.58vh',
    color: theme.palette.info.dark,
    fontSize: vw(1.32),
    letterSpacing: '0.09vw',
    lineHeight: 'unset',
  },
  interventionsListHeaderContainer: {
    minHeight: '6.07vh',
    justifyContent: 'center',
  },
  interventionsListRowContainer: {
    justifyContent: 'flex-start',
  },
  row: {
    justifyContent: 'space-between',
    paddingLeft: '1.1713vw',
  },
  interventionsListHeaderText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    color: themeColor.subheaderLight,
    paddingTop: '0.23vh',
  },
  floatRight: {
    float: 'right',
    width: '100%',
    justifyContent: 'flex-end',
    paddingRight: '2vw',
  },
  fullWidth: {
    width: '100%',
  },
  interventionsItemContainer: {
    backgroundColor: themeColor.white,
    boxShadow: `0 1px 0 0 ${themeColor.almosttransparentblack}`,
    minHeight: '6.07vh',
    cursor: 'pointer',
    justifyContent: 'center',
  },
  interventionsCellContainer: {
    justifyContent: 'flex-start',
  },
  interventionsCellInformation: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingTop: '0.23vh',
  },
  selected: {
    backgroundColor: '#C7EDF8',
  },
  bottleDepositItems: {
    height: '19.53125vh',
    marginRight: '0.732vw',
    display: 'inline-block',
  },
  icon: {
    paddingRight: '0.5vw',
  },
  extendWidth: {
    maxWidth: '100%',
  },
}));
